
// CHART CONSTANTS AND COLOR SCHEMES


export const CHART_COLORS = ['#8884d8', '#82ca9d', '#ffc658', '#ff7c7c', '#8dd1e1'];

export const SANKEY_COLORS = {
  // Source colors (left side)
  source: ['#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#ec4899', '#06b6d4'],
  // Target colors (right side)  
  target: ['#60a5fa', '#34d399', '#fbbf24', '#f87171', '#a78bfa', '#f472b6', '#22d3ee'],
  // Link colors (flows)
  link: 'rgba(59, 130, 246, 0.2)'
};

// Heatmap color scale (low to high traffic)
export const HEATMAP_COLORS = {
  gradient: [
    '#10b981', // Low - Green
    '#84cc16', // Medium-Low - Lime
    '#fbbf24', // Medium - Yellow
    '#f97316', // Medium-High - Orange
    '#ef4444', // High - Red
    '#dc2626', // Very High - Dark Red
  ],
  thresholds: [0, 0.2, 0.4, 0.6, 0.8, 1.0], // Percentage thresholds
};

// User class color schemes
export const USER_CLASS_COLORS = {
  // Vehicle types
  'vehicle': { node: '#3b82f6', link: 'rgba(59, 130, 246, 0.3)' },
  'car': { node: '#3b82f6', link: 'rgba(59, 130, 246, 0.3)' },
  'truck': { node: '#ef4444', link: 'rgba(239, 68, 68, 0.3)' },
  'bus': { node: '#8b5cf6', link: 'rgba(139, 92, 246, 0.3)' },
  'motorcycle': { node: '#f59e0b', link: 'rgba(245, 158, 11, 0.3)' },
  
  // Non-motorized
  'pedestrian': { node: '#10b981', link: 'rgba(16, 185, 129, 0.3)' },
  'cyclist': { node: '#06b6d4', link: 'rgba(6, 182, 212, 0.3)' },
  'bicycle': { node: '#06b6d4', link: 'rgba(6, 182, 212, 0.3)' },
  
  // Special categories
  'emergency': { node: '#dc2626', link: 'rgba(220, 38, 38, 0.4)' },
  'commercial': { node: '#f97316', link: 'rgba(249, 115, 22, 0.3)' },
  'public': { node: '#6366f1', link: 'rgba(99, 102, 241, 0.3)' },
  'private': { node: '#8b5cf6', link: 'rgba(139, 92, 246, 0.3)' },
  
  // Priority levels
  'high': { node: '#dc2626', link: 'rgba(220, 38, 38, 0.3)' },
  'medium': { node: '#f59e0b', link: 'rgba(245, 158, 11, 0.3)' },
  'low': { node: '#10b981', link: 'rgba(16, 185, 129, 0.3)' },
  
  // Default
  'default': { node: '#6b7280', link: 'rgba(107, 114, 128, 0.2)' }
};

export const VEHICLE_COLORS = {
  Pedestrian: "#10b981",
  Cyclist: "#3b82f6",
  Vehicle: "#f59e0b",
  Truck: "#ef4444",
  Bus: "#8b5cf6",
};

// Keys to exclude from chart rendering
export const EXCLUDED_KEYS = new Set([
  'name', 
  'week', 
  'VelBucket', 
  'event_time', 
  'total',
  'speedMPHBucket',
  'veh_type',
  'speed',
  'source',
  'target',
  'value'
]);